import { pravicePredelavaService } from '../services/pravicePredelava.service';


const state = {
    pravicePredelava: null,
    sezona:null
};

const actions = {
    load({ dispatch,commit },{sezona}) {
        commit('load');
        commit('setSezona', sezona)
          dispatch('alert/clear', "",{ root: true });

        pravicePredelavaService.load(sezona)
            .then(
                pravicePredelava => commit('load', pravicePredelava)
                //,
                //error => commit('getLoggedInFailure', error)
            );
    },
    replace({ commit },{pravicePredelava}) {
        commit('replace',pravicePredelava);

    },
    save({ dispatch, commit },{pravicePredelava}) {
     

       dispatch('alert/clear', "",{ root: true });

         pravicePredelavaService.save(pravicePredelava)
            .then(
                item => {
                    
                    commit("update",pravicePredelava);
                    
                },
                error => {
                    console.log("Shranjevanje ni uspelo");
                    //commit("update",item);
                    dispatch('alert/error', error, { root: true });
                }
            );
        
    }
};

const mutations = {
  
    load(state, pravicePredelava) {
        state.pravicePredelava = pravicePredelava;
    },
   
     setSezona(state, item) {
        state.sezona=item;
    },
    update(state, item) {
        //state.kultura = kultura;
        //state.kultura;
       
        let updated;
        let itemID = item.id
            let index = state.pravicePredelava.findIndex(p =>
                (JSON.stringify({ ...p }) === JSON.stringify(item) )
                 || itemID && p.id === itemID);
            if (index >= 0) {
                updated = Object.assign({}, item);
                state.pravicePredelava.splice(index,1,updated);
            } 

    },
   
};

export const pravicePredelava = {
    namespaced: true,
    state,
    actions,
    mutations
};
